import PropTypes from "prop-types";

import ErrorEntry from "../icons/ErrorEntry";
import CorrectEntry from "../icons/CorrectEntry";

import { Colors, getColors } from "../utils";

function SimpleText({
  id,
  name,
  color = Colors.DEFAULT,
  label,
  value,
  errors,
  subLabel,
  disabled,
  required,
  labelUpper,
  placeholder,
  labelCapitalize = true,
  ...restProps
}) {
  const colors = getColors(color);

  return (
    <div className="py-2">
      <div
        className={`
          flex
          flex-1
          text-sm
          flex-col
          ${disabled && "opacity-40"}
          ${labelCapitalize ? "capitalize" : "normal-case"}
        `}
      >
        {label && (
          <span
            className={`
              flex
              flex-row
              font-semibold
              ${colors.primary.text}
              ${labelUpper && "uppercase"}
            `}
          >
            {label}
            {required && <div className="px-1 font-bold">*</div>}
          </span>
        )}
        {subLabel && <span className="text-black font-medium">{subLabel}</span>}
      </div>
      <div
        className={`
          flex
          border
          flex-row
          relative
          min-h-3rem
          border-black
          ${label && "mt-2"}
          ${
            disabled
              ? "opacity-40 cursor-not-allowed pointer-events-none"
              : "focus-within:shadow-black"
          }
        `}
      >
        <input
          id={id}
          name={name}
          value={value}
          aria-label={name}
          autoCapitalize="none"
          placeholder={placeholder}
          className={`
            pl-2
            w-full
            text-sm
            font-medium
            text-black
            outline-none
            ${disabled ? "pointer-events-none" : ""}
          `}
          {...restProps}
        />
        {!disabled &&
          (value || (errors && errors[name])) &&
          (errors && errors[name] ? (
            <div className="absolute top-0 right-0">
              <ErrorEntry size={17} fillColor="fill-primary-red" />
            </div>
          ) : (
            <div className="absolute top-0 right-0">
              <CorrectEntry
                size={17}
                fillColor={`fill-current ${colors.primary.text}`}
              />
            </div>
          ))}
      </div>
    </div>
  );
}

SimpleText.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  errors: PropTypes.shape(),
  labelUpper: PropTypes.bool,
  subLabel: PropTypes.string,
  placeholder: PropTypes.string,
  labelCapitalize: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.oneOf([
    Colors.RED,
    Colors.BLUE,
    Colors.GREEN,
    Colors.ORANGE,
    Colors.DEFAULT
  ])
};

export default SimpleText;
